import { render, staticRenderFns } from "./slproduct-add-or-update.vue?vue&type=template&id=cf636e60&scoped=true&"
import script from "./slproduct-add-or-update.vue?vue&type=script&lang=js&"
export * from "./slproduct-add-or-update.vue?vue&type=script&lang=js&"
import style0 from "./slproduct-add-or-update.vue?vue&type=style&index=0&id=cf636e60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf636e60",
  null
  
)

export default component.exports